// AUTO-GENERATED from Snap-On engineering drawings — do not hand-edit coordinates.
// Coordinate system: mm, center-based. cx = from panel LEFT, cy = from panel TOP.
// Button (switch / fan on-off / fan speed) = 12mm circle. drop=true => accepts dropped icons.
// Socket parts, IR square, fan-speed indicator rectangles are static (not in this list / drop=false).
// SKUs #17–21 (12 module) pending finalized drawings.

export const SNAPON_BUTTON_MM = 12;
export const SNAPON_MM_PX = 3.78; // 1mm ~= 3.78px at 96dpi; panel scales via CSS transform

export const snapOnAccessories = {
  "2 module": [
    {
      "sku": 1,
      "name": "2 Switch",
      "panel": {
        "w": 119.126,
        "h": 95.123
      },
      "elements": [
        {
          "type": "switch",
          "cx": 59.436,
          "cy": 37.084,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 59.436,
          "cy": 58.039,
          "drop": true
        }
      ]
    },
    {
      "sku": 2,
      "name": "4 Switch",
      "panel": {
        "w": 119.126,
        "h": 95.123
      },
      "elements": [
        {
          "type": "switch",
          "cx": 46.863,
          "cy": 37.084,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 71.882,
          "cy": 37.084,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 46.863,
          "cy": 57.531,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 71.882,
          "cy": 57.531,
          "drop": true
        }
      ]
    },
    {
      "sku": 3,
      "name": "Fan Switch",
      "panel": {
        "w": 119.126,
        "h": 95.123
      },
      "elements": [
        {
          "type": "switch",
          "cx": 43.688,
          "cy": 47.181,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 63.373,
          "cy": 36.957,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 63.373,
          "cy": 57.404,
          "drop": true
        }
      ]
    }
  ],
  "4 module": [
    {
      "sku": 4,
      "name": "8 Switch",
      "panel": {
        "w": 151.892,
        "h": 96.901
      },
      "elements": [
        {
          "type": "switch",
          "cx": 38.735,
          "cy": 38.354,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 63.735,
          "cy": 38.354,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 88.735,
          "cy": 38.354,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 113.735,
          "cy": 38.354,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 38.735,
          "cy": 58.928,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 63.735,
          "cy": 58.928,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 88.735,
          "cy": 58.928,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 113.735,
          "cy": 58.928,
          "drop": true
        }
      ]
    },
    {
      "sku": 5,
      "name": "4 Switch 1 Fan",
      "panel": {
        "w": 151.892,
        "h": 96.901
      },
      "elements": [
        {
          "type": "switch",
          "cx": 35.052,
          "cy": 38.48,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 60.071,
          "cy": 38.48,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 35.052,
          "cy": 58.8,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 60.071,
          "cy": 58.8,
          "drop": true
        },
        {
          "type": "fan-onoff",
          "cx": 81.915,
          "cy": 48.64,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 101.727,
          "cy": 38.48,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 101.727,
          "cy": 58.8,
          "drop": true
        }
      ]
    },
    {
      "sku": 6,
      "name": "4 Switch 1 Socket",
      "panel": {
        "w": 151.892,
        "h": 96.901
      },
      "elements": [
        {
          "type": "switch",
          "cx": 39.37,
          "cy": 37.338,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 64.389,
          "cy": 37.338,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 39.37,
          "cy": 57.658,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 64.389,
          "cy": 57.658,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 105.666,
          "cy": 38.354,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 97.091,
          "cy": 50.467,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 113.983,
          "cy": 50.467,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 96.329,
          "cy": 59.467,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 114.745,
          "cy": 59.467,
          "drop": false
        }
      ]
    }
  ],
  "6 module": [
    {
      "sku": 7,
      "name": "8 Switch 1 Socket",
      "panel": {
        "w": 232.918,
        "h": 98.933
      },
      "elements": [
        {
          "type": "switch",
          "cx": 51.054,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 75.946,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 100.838,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 125.73,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 51.054,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 75.946,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 100.838,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 125.73,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 172.722,
          "cy": 39.116,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 164.147,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 181.039,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 163.385,
          "cy": 60.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 181.801,
          "cy": 60.229,
          "drop": false
        }
      ]
    },
    {
      "sku": 8,
      "name": "4 Switch 1 Fan 1 Socket",
      "panel": {
        "w": 232.918,
        "h": 98.933
      },
      "elements": [
        {
          "type": "switch",
          "cx": 47.498,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 72.517,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 47.498,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 72.517,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "fan-onoff",
          "cx": 94.234,
          "cy": 49.467,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 114.3,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 114.3,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 172.595,
          "cy": 39.223,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 164.02,
          "cy": 51.336,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 180.912,
          "cy": 51.336,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 163.258,
          "cy": 60.336,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 181.674,
          "cy": 60.336,
          "drop": false
        }
      ]
    },
    {
      "sku": 9,
      "name": "8 Switch 1 Fan",
      "panel": {
        "w": 232.918,
        "h": 98.933
      },
      "elements": [
        {
          "type": "switch",
          "cx": 53.848,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 78.848,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 103.848,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 128.848,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 53.848,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 78.848,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 103.848,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 128.848,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "fan-onoff",
          "cx": 150.692,
          "cy": 49.467,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 170.25,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 170.25,
          "cy": 59.627,
          "drop": true
        }
      ]
    },
    {
      "sku": 10,
      "name": "10 Switch",
      "panel": {
        "w": 232.918,
        "h": 98.933
      },
      "elements": [
        {
          "type": "switch",
          "cx": 66.929,
          "cy": 38.227,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 91.948,
          "cy": 38.227,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 116.967,
          "cy": 38.227,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 141.986,
          "cy": 38.227,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 167.005,
          "cy": 38.227,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 66.929,
          "cy": 58.547,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 91.948,
          "cy": 58.547,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 116.967,
          "cy": 58.547,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 141.986,
          "cy": 58.547,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 167.005,
          "cy": 58.547,
          "drop": true
        }
      ]
    },
    {
      "sku": 11,
      "name": "4 Switch 2 Socket",
      "panel": {
        "w": 232.918,
        "h": 98.933
      },
      "elements": [
        {
          "type": "socket-big-circle",
          "cx": 56.068,
          "cy": 39.116,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 47.493,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 64.385,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 46.731,
          "cy": 60.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 65.147,
          "cy": 60.229,
          "drop": false
        },
        {
          "type": "switch",
          "cx": 101.346,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 126.365,
          "cy": 39.307,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 101.346,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 126.365,
          "cy": 59.627,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 177.108,
          "cy": 39.116,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 168.533,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 185.425,
          "cy": 51.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 167.771,
          "cy": 60.229,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 186.187,
          "cy": 60.229,
          "drop": false
        }
      ]
    }
  ],
  "8 module": [
    {
      "sku": 12,
      "name": "8 Switch 1 Socket",
      "panel": {
        "w": 251.969,
        "h": 100.965
      },
      "elements": [
        {
          "type": "switch",
          "cx": 60.58,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 85.472,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 110.364,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 135.256,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 60.58,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 85.472,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 110.364,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 135.256,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 191.773,
          "cy": 40.132,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 183.198,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 200.09,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 182.436,
          "cy": 61.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 200.852,
          "cy": 61.245,
          "drop": false
        }
      ]
    },
    {
      "sku": 13,
      "name": "4 Switch 1 Fan 1 Socket",
      "panel": {
        "w": 251.969,
        "h": 100.965
      },
      "elements": [
        {
          "type": "switch",
          "cx": 57.024,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 82.043,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 57.024,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 82.043,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "fan-onoff",
          "cx": 103.76,
          "cy": 50.483,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 123.826,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 123.826,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 191.646,
          "cy": 40.239,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 183.071,
          "cy": 52.352,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 199.963,
          "cy": 52.352,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 182.309,
          "cy": 61.352,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 200.725,
          "cy": 61.352,
          "drop": false
        }
      ]
    },
    {
      "sku": 14,
      "name": "8 Switch 1 Fan",
      "panel": {
        "w": 251.969,
        "h": 100.965
      },
      "elements": [
        {
          "type": "switch",
          "cx": 63.374,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 88.374,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 113.374,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 138.374,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 63.374,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 88.374,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 113.374,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 138.374,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "fan-onoff",
          "cx": 160.218,
          "cy": 50.483,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 179.776,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "fan-speed",
          "cx": 179.776,
          "cy": 60.643,
          "drop": true
        }
      ]
    },
    {
      "sku": 15,
      "name": "10 Switch",
      "panel": {
        "w": 251.969,
        "h": 100.965
      },
      "elements": [
        {
          "type": "switch",
          "cx": 76.455,
          "cy": 39.243,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 101.474,
          "cy": 39.243,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 126.493,
          "cy": 39.243,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 151.512,
          "cy": 39.243,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 176.531,
          "cy": 39.243,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 76.455,
          "cy": 59.563,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 101.474,
          "cy": 59.563,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 126.493,
          "cy": 59.563,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 151.512,
          "cy": 59.563,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 176.531,
          "cy": 59.563,
          "drop": true
        }
      ]
    },
    {
      "sku": 16,
      "name": "4 Switch 2 Socket",
      "panel": {
        "w": 251.969,
        "h": 100.965
      },
      "elements": [
        {
          "type": "socket-big-circle",
          "cx": 56.068,
          "cy": 40.132,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 47.493,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 64.385,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 46.731,
          "cy": 61.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 65.147,
          "cy": 61.245,
          "drop": false
        },
        {
          "type": "switch",
          "cx": 110.872,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 135.891,
          "cy": 40.323,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 110.872,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "switch",
          "cx": 135.891,
          "cy": 60.643,
          "drop": true
        },
        {
          "type": "socket-big-circle",
          "cx": 196.159,
          "cy": 40.132,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 187.584,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-small-circle",
          "cx": 204.476,
          "cy": 52.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 186.822,
          "cy": 61.245,
          "drop": false
        },
        {
          "type": "socket-earth-pin",
          "cx": 205.238,
          "cy": 61.245,
          "drop": false
        }
      ]
    }
  ]
};
